import { render, staticRenderFns } from "./Tipomanufatto.vue?vue&type=template&id=ce32e438&"
import script from "./Tipomanufatto.vue?vue&type=script&lang=js&"
export * from "./Tipomanufatto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports